import React from 'react';
import Select from 'react-select';
import { getTheme } from '../../constants/SelectTheme';

const customStyles = {
  singleValue: (provided, state) => ({
    ...provided,
    color: state.data.isDisabled ? '#ffc107' : provided.color,
    fontStyle: state.data.isDisabled ? 'italic' : 'normal',
  }),
};

const SelectWrapper = ({
  name,
  label,
  showLabel = true,
  error,
  touched,
  showError = true,
  ...props
}) => (
  <div>
    {showLabel && <label htmlFor={name}>{label}</label>}
    <Select
      id={name}
      name={name}
      theme={getTheme}
      styles={customStyles}
      {...props}
    />
    {!!error && touched && showError && (
      <div className="invalid-feedback d-block">{error}</div>
    )}
  </div>
);

export default SelectWrapper;
